import React from 'react';
import PropTypes from 'prop-types';

import EditMainNutritionRow from 'components/nutritional_panels/editable_nutrition_facts/EditMainNutritionRow';
import EditSubNutritionRow from 'components/nutritional_panels/editable_nutrition_facts/EditSubNutritionRow';
import { NUTRITION_ATTRIBUTES } from 'components/upb_viewer/pdp_components/ProductNutritionFactsView';
import useFindAttributeValueByName from 'lib/hooks/product/useFindAttributeValueByName';

function FatSection({ nutritionAttributes, setNutritionAttributes }) {
  const totalFatQuantity = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.TOTAL_FAT_QUANTITYCONTAINED,
  );
  const totalFatUom = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.TOTAL_FAT_UOM,
  );
  const totalFatDailyValue = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.TOTAL_FAT_RDI_DAILYVALUEINTAKEPERCENT,
  );
  const totalFatPrecisionCode = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.TOTAL_FAT_MEASUREMENTPRECISIONCODE,
  );

  const saturatedFatQuantity = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.SATURATED_FAT_QUANTITYCONTAINED,
  );
  const saturatedFatUom = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.SATURATED_FAT_UOM,
  );
  const saturatedFatDailyValue = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.SATURATED_FAT_RDI_DAILYVALUEINTAKEPERCENT,
  );
  const saturatedFatPrecisionCode = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.SATURATED_FAT_MEASUREMENTPRECISIONCODE,
  );

  const transFattyAcidsQuantity = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.TRANSFATTY_ACIDS_QUANTITYCONTAINED,
  );
  const transFattyAcidsUom = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.TRANSFATTY_ACIDS_UOM,
  );
  const transFattyAcidsPrecisionCode = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.TRANSFATTY_ACIDS_MEASUREMENTPRECISIONCODE,
  );

  const polyUnsaturatedFatQuantity = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.POLYUNSATURATED_FAT_QUANTITYCONTAINED,
  );
  const polyUnsaturatedFatUom = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.POLYUNSATURATED_FAT_UOM,
  );
  const polyUnsaturatedFatPrecisionCode = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.POLYUNSATURATED_FAT_MEASUREMENTPRECISIONCODE,
  );

  const monoUnsaturatedFatQuantity = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.MONOUNSATURATED_FAT_QUANTITYCONTAINED,
  );
  const monoUnsaturatedFatUom = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.MONOUNSATURATED_FAT_UOM,
  );
  const monoUnsaturatedFatPrecisionCode = useFindAttributeValueByName(
    nutritionAttributes,
    NUTRITION_ATTRIBUTES.MONOUNSATURATED_FAT_MEASUREMENTPRECISIONCODE,
  );

  return (
    <>
      <EditMainNutritionRow
        title="Total Fat"
        quantity={totalFatQuantity}
        uom={totalFatUom}
        percentage={totalFatDailyValue}
        precisionCode={totalFatPrecisionCode}
        setNutritionAttributes={setNutritionAttributes}
        quantityAttribute={NUTRITION_ATTRIBUTES.TOTAL_FAT_QUANTITYCONTAINED}
        uomAttribute={NUTRITION_ATTRIBUTES.TOTAL_FAT_UOM}
        percentageAttribute={NUTRITION_ATTRIBUTES.TOTAL_FAT_RDI_DAILYVALUEINTAKEPERCENT}
        precisionCodeAttribute={NUTRITION_ATTRIBUTES.TOTAL_FAT_MEASUREMENTPRECISIONCODE}
      />
      <EditSubNutritionRow
        title="Saturated Fat"
        quantity={saturatedFatQuantity}
        uom={saturatedFatUom}
        percentage={saturatedFatDailyValue}
        precisionCode={saturatedFatPrecisionCode}
        offset={1}
        boldPercentage
        setNutritionAttributes={setNutritionAttributes}
        quantityAttribute={NUTRITION_ATTRIBUTES.SATURATED_FAT_QUANTITYCONTAINED}
        uomAttribute={NUTRITION_ATTRIBUTES.SATURATED_FAT_UOM}
        percentageAttribute={NUTRITION_ATTRIBUTES.SATURATED_FAT_RDI_DAILYVALUEINTAKEPERCENT}
        precisionCodeAttribute={NUTRITION_ATTRIBUTES.SATURATED_FAT_MEASUREMENTPRECISIONCODE}
      />
      <EditSubNutritionRow
        title={
          <span>
            <span className="font-italic">Trans </span>
            Fat
          </span>
        }
        quantity={transFattyAcidsQuantity}
        uom={transFattyAcidsUom}
        precisionCode={transFattyAcidsPrecisionCode}
        offset={1}
        setNutritionAttributes={setNutritionAttributes}
        quantityAttribute={NUTRITION_ATTRIBUTES.TRANSFATTY_ACIDS_QUANTITYCONTAINED}
        uomAttribute={NUTRITION_ATTRIBUTES.TRANSFATTY_ACIDS_UOM}
        precisionCodeAttribute={NUTRITION_ATTRIBUTES.TRANSFATTY_ACIDS_MEASUREMENTPRECISIONCODE}
      />
      <EditSubNutritionRow
        title="Polyunsaturated Fat"
        quantity={polyUnsaturatedFatQuantity}
        uom={polyUnsaturatedFatUom}
        precisionCode={polyUnsaturatedFatPrecisionCode}
        offset={1}
        setNutritionAttributes={setNutritionAttributes}
        quantityAttribute={NUTRITION_ATTRIBUTES.POLYUNSATURATED_FAT_QUANTITYCONTAINED}
        uomAttribute={NUTRITION_ATTRIBUTES.POLYUNSATURATED_FAT_UOM}
        precisionCodeAttribute={NUTRITION_ATTRIBUTES.POLYUNSATURATED_FAT_MEASUREMENTPRECISIONCODE}
      />
      <EditSubNutritionRow
        title="Monounsaturated Fat"
        quantity={monoUnsaturatedFatQuantity}
        uom={monoUnsaturatedFatUom}
        precisionCode={monoUnsaturatedFatPrecisionCode}
        offset={1}
        setNutritionAttributes={setNutritionAttributes}
        quantityAttribute={NUTRITION_ATTRIBUTES.MONOUNSATURATED_FAT_QUANTITYCONTAINED}
        uomAttribute={NUTRITION_ATTRIBUTES.MONOUNSATURATED_FAT_UOM}
        precisionCodeAttribute={NUTRITION_ATTRIBUTES.MONOUNSATURATED_FAT_MEASUREMENTPRECISIONCODE}
      />
    </>
  );
}

FatSection.propTypes = {
  nutritionAttributes: PropTypes.array,
  setNutritionAttributes: PropTypes.func,
};

export default FatSection;
